import React from 'react'
import { Subscribe } from 'unstated'
import NotesStore from '../Store/NotesStore'
import { Export2Doc } from '../Helpers'

const DownloadNotes = () => (
  <Subscribe to={[NotesStore]}>
    {({ state }) => {
      const notes = state.notes
        .filter(({ note }) => note)
        .reduce(
          (merged, current) =>
            `${merged} 
            <br> 
            <h2 style="font-size: 20px; color:#C7402D; font-weight: 500; margin-top: 32px;">
                ${current.noteTitle.title}
            </h2>
            <h3 style="font-size: 18px; color:#C7402D; font-weight: 400; margin-bottom: 16px; margin-left: 16px;">
                ${current.noteTitle.title}
            </h3> 
            ${current.note}`,
          ``,
        )

      return (
        <div className='downloadNotes'>
          <div
            id='notesDownloadContainer'
            dangerouslySetInnerHTML={{ __html: notes }}
          />
          <p onClick={() => Export2Doc('notesDownloadContainer', 'Notes')}>
            <span />
            Download Notes
          </p>
        </div>
      )
    }}
  </Subscribe>
)

export default DownloadNotes
